import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { Divider } from '@mui/material';

import OnboardingCoachNotificationsContext
from '../../context/OnboardingCoachNotificationsContext/OnboardingCoachNotificationsContext';

import {
  StyledModal,
  ModalContentWrapper,
  AnnouncementSection,
  SettingsActionsSection,
  Title,
  SubTitle,
  CrossButton,
  Cross,
  StyledList,
  HelpText,
} from './styles';

import texts from './texts.json';
import CoachOnboardingTask from './CoachOnboardingTask';
import VideoModal from './VideoModal/VideoModal';
import onbordingURLs from './onboardingURLs.json';

const CoachMissingSettingsModal = ({
  isOpen,
  onClose,
  missingSettings,
}) => {
  const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);
  const [isWelcomeVideoOpened, setIsWelcomeVideoOpened] = useState(false);
  const { newCoachTaskCount } = useContext(OnboardingCoachNotificationsContext);

  // Check if any of the onboarding tasks are completed
  const allSettingsMissing = missingSettings.length === newCoachTaskCount;

  // Auto-open Welcome video modal when all settings are missing
  useEffect(() => {
    if (allSettingsMissing && isOpen && !isWelcomeVideoOpened) {
      setIsVideoModalOpen(true);
      setIsWelcomeVideoOpened(true);
    }
  }, [allSettingsMissing, isOpen, isWelcomeVideoOpened]);

  return (
    <>
      <StyledModal open={isOpen} onClose={onClose}>
        <ModalContentWrapper>
          <CrossButton onClick={onClose}>
            <Cross />
          </CrossButton>
          <AnnouncementSection>
            <Title>{texts.title}</Title>
            <SubTitle>{texts.subTitle}</SubTitle>
            <HelpText onClick={() => setIsVideoModalOpen(true)}>
              {texts.helpText}
            </HelpText>
          </AnnouncementSection>
          <Divider />
          <SettingsActionsSection>
            <StyledList>
              {missingSettings.map((task) => (
                <CoachOnboardingTask
                  key={task.label}
                  {...task}
                  onClose={onClose}
                />
              ))}
            </StyledList>
          </SettingsActionsSection>
        </ModalContentWrapper>
      </StyledModal>
      <VideoModal
        isOpen={isVideoModalOpen}
        onClose={() => setIsVideoModalOpen(false)}
        videoUrl={onbordingURLs.welcomeVideo}
        videoTitle={texts.videoTitle}
      />
    </>
  );
};

CoachMissingSettingsModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  missingSettings: PropTypes.arrayOf(
    PropTypes.shape({
      path: PropTypes.string,
      buttonText: PropTypes.string,
      label: PropTypes.string,
    }),
  ),
};

CoachMissingSettingsModal.defaultProps = {
  isOpen: false,
  onClose: () => { },
  missingSettings: [],
};

export default CoachMissingSettingsModal;
